<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { baseURL } from './constants/URL'
import CardDiv from '@components/card-div'
import con from './services/connection'
import store from '@state/store'
import Vue from 'vue'
import Snackbar from '@components/the-snackbar'
import Modal from '@modal/the-feedback'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title
        ? `${title} | ${
            window.PARAMETROS ? window.PARAMETROS.escritorio.nome || 'AAWZ' : ''
          }`
        : window.PARAMETROS
        ? window.PARAMETROS.escritorio.nome || 'AAWZ'
        : ''
    },
  },
  components: { Layout, CardDiv, Modal, Snackbar },
  data() {
    return {
      bus: new Vue(),
      menuInstitucional: [
        {
          text: 'Por que AAWZ',
          link: 'https://aawz.com.br/porque.html',
        },
        {
          text: 'M&A',
          link: 'https://aawz.com.br/mea.html',
        },
        {
          text: 'Marketing',
          tag: 'agência',
          link: 'https://aawz.com.br/marketing.html',
        },
        {
          text: 'Plataforma',
          tag: 'tecnologia',
          link: 'https://www.plataforma.aawz.com.br/',
        },
        {
          text: 'Planos',
          link: '/relatorios',
        },
        {
          text: 'Contato',
          link: 'https://aawz.com.br/#contato',
        },
      ],
    }
  },
  computed: {
    bg() {
      return store.getters['parameters/bg']
    },
    showHeader() {
      return window.location.href === window.top.location.href
    },
    showInstitucionalHeader() {
      return window.location.pathname.includes('/relatorios')
    },
  },
  created() {
    this.bus.$on('download_app', this.redirectAppStore)
  },
  methods: {
    redirectAppStore() {
      const SO = this.getMobileOperatingSystem()
      switch (SO) {
        case 'Windows Phone':
          alert('Aplicado indisponível para Windows Phone')
          break
        case 'iOS':
          window.open(APPLE_STORE_LINK, '_blank')
          break
        case 'Android':
        case 'unknown':
          window.open(PLAY_STORE_LINK, '_blank')
          break
        default:
          window.open(PLAY_STORE_LINK, '_blank')
      }
    },
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      }
      if (/android/i.test(userAgent)) {
        return 'Android'
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }
      return 'unknown'
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<template>
  <v-app id="app" style="background-color: inherit">
    <v-app-bar app v-if="!showInstitucionalHeader && showHeader">
      <BaseLogo height="40" align="left" justify="left" />
      <v-spacer></v-spacer>

      <v-btn
        text
        style="text-decoration: underline; margin-right: 10px;"
        class="mr-3"
        @click="redirectAppStore"
      >
        Baixar o app
      </v-btn>
    </v-app-bar>

    <v-app-bar
      app
      v-if="showInstitucionalHeader && showHeader"
      color="#5ebe7b"
      style="color: white;"
    >
      <BaseLogo
        height="60"
        width="165"
        align="left"
        justify="left"
        url="https://aawz.com.br/assets/images/holding/logo%20-%20aawz%20partners-01.png"
      />
      <v-spacer />

      <v-btn
        text
        style="color:white;"
        v-for="m in menuInstitucional"
        @click="openUrl(m.link)"
        class="hidden-sm-and-down"
      >
        <b> {{ m.text }} </b>
        <small class="tag" v-if="m.tag"> {{ m.tag }} </small>
      </v-btn>

      <v-spacer class="hidden-sm-and-down" />
      <v-btn
        text
        style="text-decoration: underline; margin-right: 10px; color: white;"
        class="mr-3 hidden-sm-and-down"
        @click="openUrl('https://www.portal.aawz.com.br/login')"
      >
        Login
      </v-btn>

      <div class="hidden-md-and-up text-white">
        <v-menu close-on-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-on="on">
              <v-icon color="white">
                mdi-menu
              </v-icon>
            </v-btn>
          </template>

          <v-list style="background-color: #5ebe7b;">
            <v-list-item
              v-for="m in menuInstitucional"
              @click="openUrl(m.link)"
            >
              <v-list-item-title style="color: white;">
                {{ m.text }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                style="color: white;"
                @click="openUrl('https://www.portal.aawz.com.br/login')"
              >
                Login
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-content>
      <!-- Provides the application the proper gutter -->
      <v-container class="fill-height" fluid style="max-width: 100vw;">
        <router-view :bus="bus"></router-view>
      </v-container>
    </v-content>

    <Snackbar />
    <Modal />

    <v-footer
      v-if="showHeader && !showInstitucionalHeader"
      class="text-secondary"
      style="background-color: transparent; font-size: 12px"
    >
      <img
        src="@assets/images/logo-aawz.png"
        srcset="
          @assets/images/logo-aawz@2x.png 2x,
          @assets/images/logo-aawz@3x.png 3x
        "
      />
      <v-icon color="secondary" class="ml-2" small>
        mdi-copyright
      </v-icon>
      2020 Copyright AAWZ
    </v-footer>
  </v-app>
</template>

<style lang="sass">
@import '~normalize.css/normalize.css'
@import '~nprogress/nprogress.css'
@import './design/index.sass'
// @import './design/style'

.subhead
  margin-bottom: 8px
  font-size: rem(20px)
  font-weight: 300
  line-height: 1.3
  color: $dark
  font-weight: 500
  text-transform: uppercase

.subtitle
  margin-bottom: 31px
  font-size: 0.75rem
  font-weight: bold
  color: $dark

#nprogress .bar
  background: #1966b1

#nprogress .spinner-icon
  border-top-color: #1966b1
  border-left-color: #1966b1

.tag
  -webkit-box-pack: center
  -ms-flex-pack: center
  justify-content: center
  position: absolute
  bottom: -17px
  left: 0
  right: 0
  background-color: #1c562b
  border-radius: 22px
  width: -webkit-fit-content
  width: -moz-fit-content
  width: fit-content
  height: 20px
  -webkit-box-align: center
  -ms-flex-align: center
  align-items: center
  text-align: center
  display: -webkit-box
  display: -ms-flexbox
  display: flex
  margin: auto
  padding-left: 5px
  padding-right: 5px
</style>

<!-- This should generally be the only global CSS in the app.
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  background: $color-body-bg;
}
#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}
</style>-->
